import React from "react";
import { Link } from "react-router-dom";
import { ShoppingBag, Home } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="min-h-screen flex items-center justify-center px-5 text-center">
      <div className="max-w-md">
        <p className="font-accent text-chick text-3xl">No worries</p>
        <h1 className="font-heading uppercase text-4xl sm:text-5xl tracking-tighter mt-1">Payment cancelled</h1>
        <p className="text-cream/70 mt-3">Your cart is still saved. Pick up right where you left off whenever you’re ready.</p>
        <div className="flex flex-wrap gap-3 justify-center mt-8">
          <Link to="/checkout" data-testid="cancel-retry" className="flex items-center gap-2 bg-orange text-primary-foreground font-bold uppercase px-6 py-3.5 rounded-md hover:scale-105 transition-transform">
            <ShoppingBag className="w-4 h-4" /> Back to Checkout
          </Link>
          <Link to="/" data-testid="cancel-home" className="flex items-center gap-2 border border-cream/40 text-cream font-bold uppercase px-6 py-3.5 rounded-md hover:bg-cream hover:text-brown transition-colors">
            <Home className="w-4 h-4" /> Home
          </Link>
        </div>
      </div>
    </div>
  );
}
